import { render, staticRenderFns } from "./podForm.vue?vue&type=template&id=c0ee57e6&scoped=true"
import script from "./podForm.vue?vue&type=script&lang=js"
export * from "./podForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ee57e6",
  null
  
)

export default component.exports